import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmailRulesServiceProvider } from '../../api/email-rules'

const EmailRulesService = EmailRulesServiceProvider()
const name = 'getEmailRule'

export default (id) => (asyncAction(
  name,
  EmailRulesService.getEmailRule,
  { id }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/email-rules/getEmailRule.js